import { fallbackPrices, type PlanPricing } from '@/data/pricing/fallbackPrices';

export function usePricingData() {
  const getPlan = (key: string): PlanPricing | undefined => fallbackPrices[key];

  return {
    prices: fallbackPrices,
    getPlan,
    isLoading: false,
    isError: false,
    isFallback: false,
  };
}

export type { PlanPricing };
